import React from 'react';
import ContentDivider from '~/components/shared/dividers/ContentDivider';
import DataRow from './DataRow';

const DataTableComponent = ({ rows, showContentDivider }) => (
  <section className="data-table">
    <div className="section-gutter">
      {rows.map((row) => (
        <DataRow
          description={row.description}
          key={row.guid}
          sections={row.sections}
          title={row.title}
        />
      ))}
    </div>
    {showContentDivider && <ContentDivider />}
  </section>
);

export default DataTableComponent;
